// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2eslc","empty":"ModalGraph_empty__31elF"};